import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GraphFileBrowser } from '@microsoft/file-browser';
import api from 'lib/api';
import Modal from 'containers/Modals/Modal';
import { Spinner } from 'UI';
import { Button, Icon, translate } from '@haldor/ui';
import { getOnBehalfOfAccessToken } from 'actions/user';
var modalStyles = {
  content: {
    width: '60%',
    margin: '0 auto',
    marginBottom: '40px',
    padding: '0',
    borderRadius: '7px'
  }
};

var OnedrivePicker = /*#__PURE__*/function (_Component) {
  _inherits(OnedrivePicker, _Component);

  var _super = _createSuper(OnedrivePicker);

  function OnedrivePicker(props) {
    var _this;

    _classCallCheck(this, OnedrivePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAuthenticationToken", function () {
      return new Promise(function (resolve) {
        _this.props.getOnBehalfOfAccessToken(_this.props.user.userId, "Files.ReadWrite.All").then(function () {
          resolve(_this.props.access_token);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFile", function (file) {
      return new Promise(function (resolve) {
        api.getOneDriveFile('https://graph.microsoft.com/beta/me/drives/' + file.driveItem_203[1] + '/items/' + file.driveItem_203[2], _this.props.access_token).then(function (response) {
          if (response.data != null && response.data["package"] != null) {
            if (response.data["package"].type != null && response.data["package"].type == "oneNote") {
              resolve();
            }
          }

          resolve({
            name: response.data.name,
            url: response.data['@microsoft.graph.downloadUrl'],
            id: 0,
            type: response.data['file'].mimeType
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBrowserSuccess", function (keys) {
      var addError = _this.props.addError;

      _this.setState({
        loadingPicker: true
      });

      var pickedItems = [];
      Promise.all(keys.map(function (file) {
        return new Promise(function (resolve, reject) {
          _this.getFile(file).then(function (data) {
            resolve(data);
          });
        });
      })).then(function (selected) {
        selected.map(function (sel) {
          if (sel != null) {
            pickedItems.push(sel);
          } else {
            addError("OneNote files is not allowed", "error");
          }
        }); // Filter duplicate items with the same key property

        pickedItems = pickedItems.filter(function (obj, pos, arr) {
          return arr.map(function (mapObj) {
            return mapObj['name'];
          }).indexOf(obj['name']) === pos;
        });

        _this.setState({
          modal: false,
          loadingPicker: false
        }, function () {
          _this.props.onUpdate(pickedItems);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupSelect", function (group) {
      _this.setState({
        graphPickerUrl: 'https://graph.microsoft.com/beta/groups/' + group.graphId,
        loading: true,
        activeSelection: group.graphId
      }, function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGoOneDrive", function () {
      _this.setState({
        graphPickerUrl: 'https://graph.microsoft.com/beta/me/',
        loading: true,
        activeSelection: 'me'
      }, function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderModalContent", function () {
      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var meClassname = 'section-item';

      if (_this.state.activeSelection == 'me') {
        meClassname = meClassname + ' active';
      }

      return /*#__PURE__*/React.createElement("div", null, _this.state.loadingPicker ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("h3", {
        style: {
          padding: '0.5rem 0'
        }
      }, _this.props.translate('places')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1.5rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        onClick: _this.onGoOneDrive,
        className: meClassname
      }, "My OneDrive"), _this.props.groups.map(function (group) {
        var classname = 'section-item';

        if (_this.state.activeSelection == group.graphId) {
          classname = classname + ' active';
        }

        return /*#__PURE__*/React.createElement("div", {
          key: 'group-' + group.graphId,
          className: classname,
          onClick: function onClick(e) {
            _this.onGroupSelect(group);
          }
        }, group.title);
      })), /*#__PURE__*/React.createElement("div", {
        className: "ms-graph-file-picker"
      }, /*#__PURE__*/React.createElement(GraphFileBrowser, {
        getAuthenticationToken: _this.getAuthenticationToken,
        itemMode: "multiple",
        endpoint: _this.state.graphPickerUrl,
        onSuccess: _this.onBrowserSuccess,
        onCancel: _this.closeModal,
        key: "upload-wrapper-new_picker-element"
      })));
    });

    _this.state = {
      loadingPicker: false,
      loading: false,
      modal: false,
      graphPickerUrl: 'https://graph.microsoft.com/beta/me',
      activeSelection: 'me'
    };

    if (_this.props.openPicker != null) {
      _this.props.openPicker(_this.openModal);
    }

    return _this;
  }

  _createClass(OnedrivePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "upload-wrapper",
        key: "upload-wrapper-picker"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modal,
        type: "file-picker editor-block-modal",
        onClose: this.closeModal,
        style: modalStyles
      }, this.renderModalContent()), /*#__PURE__*/React.createElement("div", {
        id: "upload",
        className: "upload-container"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.openModal();
        }
      }, this.props.translate('Add files'))));
    }
  }]);

  return OnedrivePicker;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    groups: state.sections.educationGroups,
    user: state.user.currentUser,
    access_token: state.user.accessToken
  };
}

export default connect(mapStateToProps, {
  getOnBehalfOfAccessToken: getOnBehalfOfAccessToken
})(OnedrivePicker);